const styles = {
  typography: {
    fontFamily: 'Quicksand',
    fontSize: '14px',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '3px',
    color: '#757687',
    padding: '10px'
  },
  menu: {
    fontFamily: 'Quicksand',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '27px',
    color: '#757687'

  },
  icon: {
    fontSize: '20px'
  }
};

export default styles;
